export enum PricingCategoryEnumType {
  FederalFiling = 'FederalFiling',
  StateFiling = 'StateFiling',
  PostalMailing = 'PostalMailing',
  TinMatching = 'TinMatching',
  OnlineFiling = 'OnlineFiling',
}

export enum ResourceCategoryType {
  General = 'General',
  Extension = 'Extension',
  Excise = 'Excise',
  Exempt = 'Exempt',
  InformationReturns = 'InformationReturns',
  Employment = 'Employment',
  Integrations = 'Integrations',
  Boir = 'Boir',
  BusinessTax = 'BusinessTax',
}

export enum DeviceType {
  Web = 'Web',
  Android = 'Android',
  iOS = 'iOS',
}

export enum UserRoleType {
  Owner = 'Owner',
  Admin = 'Admin',
  Member = 'Member',
}

export enum MemberRoleType {
  Preparer = 'Preparer',
  Approver = 'Approver',
  Transmitter = 'Transmitter',
}

export enum PartnerType {
  None = 'None',
  Business = 'Business',
  TaxProfessional = 'Tax Professional',
  Influencer = 'Influencer',
  Association = 'Association',
  SoftwareProvider = 'Software Provider',
}
export enum StatusType {
  Success = 'Success',
  Failure = 'Failure',
  Warning = 'Warning',
}

export enum FormNameType {
  Blank = 'Blank',
  Form7004 = 'Form7004',
  Form4868 = 'Form4868',
  Form8868 = 'Form8868',
  Form8809 = 'Form8809',
  Form2290 = 'Form2290',
  Form8849 = 'Form8849',
  Form2290Amendment = 'Form2290Amendment',
  FormW2 = 'FormW2',
  FormW2c = 'FormW2c',
  Form1099A = 'Form1099A',
  Form1099B = 'Form1099B',
  Form1099C = 'Form1099C',
  Form1099CAP = 'Form1099CAP',
  Form1099DA = 'Form1099DA',
  Form1099DIV = 'Form1099DIV',
  Form1099G = 'Form1099G',
  Form1099H = 'Form1099H',
  Form1099INT = 'Form1099INT',
  Form1099K = 'Form1099K',
  Form1099LS = 'Form1099LS',
  Form1099LTC = 'Form1099LTC',
  Form1099MISC = 'Form1099MISC',
  Form1099NEC = 'Form1099NEC',
  Form1099OID = 'Form1099OID',
  Form1099PATR = 'Form1099PATR',
  Form1099Q = 'Form1099Q',
  Form1099QA = 'Form1099QA',
  Form1099R = 'Form1099R',
  Form1099S = 'Form1099S',
  Form1099SA = 'Form1099SA',
  Form1099SB = 'Form1099SB',
  Form990N = 'Form990N',
  Form990EZ = 'Form990EZ',
  Form990 = 'Form990',
  Form990PF = 'Form990PF',
  Form990T = 'Form990T',
  Form1120POL = 'Form1120POL',
  Form940 = 'Form940',
  Form941 = 'Form941',
  Form941SP = 'Form941SP',
  Form943 = 'Form943',
  Form944 = 'Form944',
  Form945 = 'Form945',
  Form94XPin = 'Form94xPIN',
  Form941ScheduleR = 'Form941ScheduleR',
  Form941X = 'Form941X',
  Form940Amendment = 'Form940Amendment',
  Form1094B = 'Form1094B',
  Form1094C = 'Form1094C',
  Form1095B = 'Form1095B',
  Form1095C = 'Form1095C',
  Form199 = 'Form199',
  Form109 = 'Form109',

  FormW9 = 'FormW9',
  BOI = 'BOI',
  Form941BulkUpload = 'Form941BulkUpload',
  Form1097BTC = 'Form1097BTC',
  Form1098 = 'Form1098',
  Form1098C = 'Form1098C',
  Form1098E = 'Form1098E',
  Form1098F = 'Form1098F',
  Form1098Q = 'Form1098Q',
  Form1098T = 'Form1098T',
  Form3921 = 'Form3921',
  Form3922 = 'Form3922',
  Form5498 = 'Form5498',
  Form5498ESA = 'Form5498ESA',
  Form5498SA = 'Form5498SA',
  Form5498QA = 'Form5498QA',
  FormW2G = 'FormW2G',
  Form1042S = 'Form1042S',
  Form943X = 'Form943X',
  Form945X = 'Form945X',
  Form7004BulkUpload = 'Form7004BulkUpload',
  Form4868BulkUpload = 'Form4868BulkUpload',
  FormW8BEN = 'FormW8BEN',
  Form8655 = 'Form8655',
  Form5227 = 'Form5227',
  Form1120S = 'Form1120S',
  Form15397 = 'Form15397',
  Form1065 = 'Form1065',
  RecipientBulkUpload = 'RecipientBulkUpload',
  FilerBulkUpload = 'FilerBulkUpload',
}

export enum SkeletonType {
  Dashboard = 'Dashboard',
  FUM = 'FUM',
  Review = 'Review',
  Filer = 'Filer',
  ActivityLog = 'ActivityLog',
  Cart = 'Cart',
  OrderHistory = 'OrderHistory',
  ChangePassword = 'ChangePassword',
  Form2290Accordion = 'Form2290Accordion',
  LeftMenu = 'LeftMenu',
  BusinesssListPopup = 'BusinesssListPopup',
  Form2290ReturnSummary = 'Form2290ReturnSummary',
  Form8849ReturnSummary = 'Form8849ReturnSummary',
  Form2290AmendmentReturnSummary = 'Form2290AmendmentReturnSummary',
  ChooseForm = 'ChooseForm',
  VinListPopup = 'VinListPopup',
  AddPayer = 'AddPayer',
  SchdeuleEPage1 = 'SchdeuleEPage1',
  EinProfileDetails = 'EinProfileDetails',
  EinProfileC2FTab = 'EinProfileC2FTab',
}
